// src/pages/PendingApprovalPage.jsx
import { Building2, Clock, LogOut, XCircle } from 'lucide-react';
import { useAuth0 } from '@/hooks/useAuth';

export default function PendingApprovalPage({ rejected = false, outroCondominio = false }) {
  const { logout, user } = useAuth0();

  const bloqueado = rejected || outroCondominio;
  const Icon = outroCondominio ? Building2 : rejected ? XCircle : Clock;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className={`mx-auto flex h-16 w-16 items-center justify-center rounded-full ${bloqueado ? 'bg-red-100 dark:bg-red-900/30' : 'bg-amber-100 dark:bg-amber-900/30'}`}>
          <Icon className={`h-8 w-8 ${bloqueado ? 'text-red-600 dark:text-red-400' : 'text-amber-600 dark:text-amber-400'}`} />
        </div>

        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          {outroCondominio
            ? 'Conta de outro condomínio'
            : rejected ? 'Acesso não autorizado' : 'Aguardando aprovação'}
        </h2>

        <p className="text-sm text-gray-600 dark:text-gray-400">
          {outroCondominio
            ? 'Sua conta está vinculada a outro condomínio e não pode acessar este. Entre com a conta deste condomínio ou fale com o administrador.'
            : rejected
            ? 'Sua solicitação de acesso não foi autorizada por um administrador.'
            : 'Sua conta foi criada, mas ainda precisa ser aprovada por um administrador antes de você acessar o sistema.'}
        </p>

        {user?.email && (
          <p className="text-xs text-gray-400 dark:text-gray-500">{user.email}</p>
        )}

        <button
          type="button"
          onClick={logout}
          className="flex w-full items-center justify-center gap-2 rounded-md border border-gray-300 bg-white py-3 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
        >
          <LogOut className="h-4 w-4" />
          Sair
        </button>
      </div>
    </div>
  );
}
